const API_BASE_URL = process.env.REACT_APP_API_URL || 'https://roadwatch-web-backend.onrender.com';

export default API_BASE_URL;
